import { make } from "vuex-pathify";
import { getAPI } from "@/store/restAPI.js";
import { postAPI } from "@/store/restAPI.js";

// initial state
const state = {
  tenderList: [],
  loading: 0,
  tenderEdit: null,
  statusSave: null,
};

// getters
const getters = {};

// actions
const actions = {
  clearTenderEdit({ commit }) {
    commit("SET_TENDER_EDIT", {
      tenderToSave: {
        id: null,
        description: null,
      },
      isNew: true,
    });
  },
  delete({ commit }, payload) {
    commit("SET_LOADING", true);
    let id = payload.id;
    return postAPI("layaway/deleteTender?id=" + id)
    .then(response => {
      if (response.status !== "OK")
        throw new Error(response.description);
      return response;
    })
    .finally(() => commit("SET_LOADING", false));
  },
  retrieveTender({ commit }, payload) {
    let id = payload.id;
    let description = payload.description;
    commit("SET_LOADING", true);
    commit("SET_TENDER_EDIT", {
      tenderToSave: {
        id: id,
        description: description,
      },
      isNew: false,
    });
    commit("SET_LOADING", false);
  },
  saveOrEdit({ commit }, payload) {
    commit("SET_LOADING", true);
    let tenderEdit = payload.tenderEdit;
    return postAPI("layaway/saveTender", tenderEdit)
    .then(function (response) { commit("SET_STATUS_SAVE", response) })
    .finally(function () { commit("SET_LOADING", false) });
  },
  search({ commit }, payload) {
    let id = payload.id;
    let description = payload.description;
    commit("SET_LOADING", true);
    return getAPI("layaway/searchTender", {
      id: id,
      description: description,
    })
    .then(response => commit("SET_TENDER_LIST", response))
    .finally(() => commit("SET_LOADING", false));
  },
};

// mutations
const mutations = {
  ...make.mutations(state)
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};